import Yup from '~/utils/validations/yup';

export const schemaValidation = Yup.object().shape({
  externalId: Yup.number().typeError('Please enter a valid number').required(),
});
